import ApplicationContextualHelp from "../../../../components/application/ApplicationContextualHelp";

export default function ExpertBandReferenceHelp() {
  return (
    <ApplicationContextualHelp
      label="About the expert reference band"
      title="About reference feedback"
    >
      <p>This feedback is based on ratings from the reference panel in the Perceptual Voice Qualities Database (PVQD; Walden, 2022). The light band shows the full range of ratings for this voice, and the darker band shows where most ratings fell. Your mark shows where your rating sits in comparison. The aim is to help you calibrate your listening, not to identify a single “correct” score.</p>
      <p>When rater-average marks are shown, each mark represents one governed rater/source-slot average. Each average combines that rater's two governed listens when paired evidence is available. The marks are rater averages, not six separate sitting-level ratings, and they do not identify individual raters.</p>
    </ApplicationContextualHelp>
  );
}
